<template>
  <ContentSection>
    <Container>
      <div>
        <!-- TITLE -->
        <h2
          v-if="data.heading"
          v-animate-in-from-bottom
          class="mb-3 typo-heading-lg sm:mb-4 sm:typo-heading-xl"
          v-html="data.heading"
        />

        <!-- POOLS DESKTOP -->
        <ul
          v-animate-children-in-from-bottom
          class="grid grid-cols-[repeat(auto-fill,_minmax(35rem,_1fr))] gap-5 max-sm:hidden sm:gap-6"
        >
          <li
            v-for="pool in data.pools"
            :key="pool.id"
            class="max-w-full"
          >
            <Pool
              :pool="pool"
              :unit="data.unit"
              :unit-prefix="data.unit_prefix"
              :segment-config="pool.segment_config"
              :class="!data.color_theme?.value || data.color_theme?.value === 'blue' ? `
                bg-theme-500 text-white
              ` : `bg-theme-200`"
              :color-theme="data.color_theme?.value"
              :style="colorTheme"
            />
          </li>
        </ul>
      </div>
    </Container>

    <!-- POOLS MOBILE SlIDER -->
    <ul
      v-if="data.pools.length"
      ref="sliderContainer"
      v-drag-scroll
      v-animate-children-in-from-left
      class="flex select-none gap-5 pr-11 sm:hidden"
    >
      <li
        v-for="pool in data.pools"
        :key="pool.id"
      >
        <Pool
          :pool="pool"
          :unit="data.unit"
          :unit-prefix="data.unit_prefix"
          :segment-config="pool.segment_config"
          :class="!data.color_theme?.value || data.color_theme?.value === 'blue' ? `bg-theme-500 text-white` : `
            bg-theme-200
          `"
          :color-theme="data.color_theme?.value"
          :style="colorTheme"
          class="w-[75dvw] translate-x-container"
        />
      </li>
    </ul>

    <Container v-animate-in-from-bottom class="mt-4 sm:hidden">
      <!-- PAGINATION -->
      <PaginationSlider
        :amount-pages="sliderContainer?.amountPages?.value || 1"
        :active-index="sliderContainer?.activeIndex?.value || 0"
        @scroll-to-item="sliderContainer?.scrollToItem ? sliderContainer?.scrollToItem($event) : null"
      />
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
import type { DragElement } from '~/plugins/dragScroll'
import type { ComponentsMainOverviewPoolsFragment } from '#gql'

const props = defineProps<{
  data: Enforce<ComponentsMainOverviewPoolsFragment>

}>()

const sliderContainer = ref<DragElement | null>(null)

const colorTheme = useGetColorThemeStylesComponent(props.data.color_theme?.value)
</script>
